module.exports = __webpack_public_path__ + "static/media/bg-1600.174f3ff1.jpeg";